module.exports = __webpack_public_path__ + "media/images/insurance-177ce6d256bce0682b4a2632661d8064.png";